<template>
  <section class="button-group">
    <div class="button-section">
      <button-text
        v-if="!disabledDelete"
        class="delete-row-button"
        :callback="deleteRowButton"
        :is-type="(isEqualLocation || isLoadingState) || selectedCount === 0 ? 3 : 2"
      >
        <span class="text">-</span>

        <span class="text">행 삭제 ({{ selectedCount }})</span>
      </button-text>

      <button-text
        v-if="!disabledInsert"
        class="add-row-button"
        :callback="addRowButton"
        :is-type="isEqualLocation || isLoadingState ? 3 : 1"
      >
        <span class="text">+</span>

        <span class="text">행 추가</span>
      </button-text>

      <!-- <input type="checkbox" id="checkbox" v-model="check_sms_permitted" />
      <label for="checkbox">발행</label>-->
    </div>
  </section>
</template>

<script>
import ButtonText from "@/spa/components/LayoutButtonText";

export default {
  name: "ButtonGroup",
  components: {
    ButtonText
  },
  props: {
    selectedCount: Number,
    insertRowFunction: Function,
    deleteRowFunction: Function,
    disabledInsert: Boolean,
    disabledDelete: Boolean
  },
  methods: {
    addRowButton() {
      this.insertRowFunction();
      this.$table.updateField();
    },
    deleteRowButton() {
      // eslint-disable-next-line
      if (confirm("정말 삭제하시겠습니까?")) {
        this.deleteRowFunction();
      }
    }
  },
  computed: {
    isEqualLocation() {
      const location = this.$route.name.toLowerCase();

      return location === "details";
    },

    isLoadingState() {
      return this.$store.getters.isLoadingState;
    }
  }
};
</script>

<style lang="scss" scoped>
.button-group {
  display: flex;

  justify-content: space-between;
  align-content: center;
  align-items: center;

  width: auto;
  height: auto;

  text-align: center;

  margin-bottom: 20px;

  .button-section {
    display: flex;

    justify-content: center;
    align-content: center;
    align-items: center;

    flex-direction: row;

    .row-button {
      width: 150px;
      height: 40px;
    }

    .add-row-button,
    .delete-row-button {
      width: 150px;
      height: 40px;
      margin-right: 20px;
    }

    .text {
      white-space: nowrap;
      margin: 0 12px 0 12px;
    }
  }
}

@media screen and (max-width: 1024px) {
  .button-group {
    margin: 0 0 12px 0;

    .button-section {
      .add-row-button,
      .delete-row-button {
        width: 150px;
        height: 40px;

        .text {
          white-space: nowrap;
          margin: 0 12px 0 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/table/components/ButtonGroup.vue